(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerWrapper = document.querySelector('.header-wrapper');
			this.headerIsAlwaysSticky =
				this.getAttribute('data-sticky-type') === 'always';
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.headerCoords = {};
			this.calcHeaderCoords();

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);
		}

		disconnectedCallback() {
			this.removeEventListener(
				'preventHeaderReveal',
				this.hideHeaderOnScrollUp,
			);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		calcHeaderCoords() {
			const clientRect = this.getBoundingClientRect();
			const pageYOffset =
				window.pageYOffset || document.documentElement.scrollTop;
			this.headerCoords.bottom = pageYOffset + clientRect.bottom;
			this.headerCoords.top = pageYOffset + clientRect.top;
		}

		onScroll() {
			const scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;

			if (this.headerIsAlwaysSticky) {
				if (this.header.classList.contains('color-background-overlay')) {
					if (scrollTop > this.header.offsetHeight + 1) {
						this.header.classList.remove('color-background-overlay');
						this.header.classList.add(
							'color-background-overlay-hidden',
							'shopify-section-header-sticky',
						);
					}
				}

				if (this.header.classList.contains('color-background-overlay-hidden')) {
					if (scrollTop < this.header.offsetHeight) {
						this.header.classList.add('color-background-overlay');
						this.header.classList.remove(
							'color-background-overlay-hidden',
							'shopify-section-header-sticky',
						);
					}
				}
			}

			if (
				scrollTop > this.currentScrollTop &&
				scrollTop > this.headerCoords.bottom
			) {
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (
				scrollTop < this.currentScrollTop &&
				scrollTop > this.headerCoords.bottom
			) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false;
					}, 66);

					requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerCoords.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
			);
			this.closeMenuDisclosure();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');

			if (this.header.classList.contains('color-background-overlay')) {
				this.header.classList.remove('color-background-overlay');
				this.header.classList.add('color-background-overlay-hidden');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			);

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				this.header.classList.add('color-background-overlay');
				this.header.classList.remove('color-background-overlay-hidden');
			}
		}

		closeMenuDisclosure() {
			this.disclosures =
				this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (typeof DetailsDisclosure !== 'undefined') {
				this.disclosures.forEach(disclosure => {
					disclosure.close();
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach(disclosureList => {
				disclosureList.setAttribute('hidden', true);
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfd-brand-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lfd-brand-slideshow')) customElements.define('lfd-brand-slideshow', class extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.lfd-brands__track');
    this.slides = [...this.querySelectorAll('.lfd-brands__slide')];
    if (this.slides.length < 2) return;
    this.abort = new AbortController();
    const on = (el, name, fn) => el.addEventListener(name, fn, {signal:this.abort.signal});
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.reduced.matches;
    this.hovered = false; this.focused = false; this.visible = false;
    this.toggle = this.querySelector('[data-toggle]');
    const updateToggle = () => {if(this.toggle){this.toggle.textContent=this.paused?this.dataset.play:this.dataset.pause;this.toggle.setAttribute('aria-pressed',String(this.paused));}};
    this.step = direction => {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 1) return;
      const width = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      let left = this.track.scrollLeft + direction * width;
      if(direction > 0 && this.track.scrollLeft >= max - 3) left = 0;
      if(direction < 0 && this.track.scrollLeft <= 3) left = max;
      this.track.scrollTo({left,behavior:this.reduced.matches?'instant':'smooth'});
    };
    const update = () => {
      const left=this.track.scrollLeft; const width=this.slides[1].offsetLeft-this.slides[0].offsetLeft;
      const first=Math.round(left/width)+1; const count=Math.max(1,Math.round(this.track.clientWidth/width));
      this.querySelector('[data-position]').textContent=`${first}–${Math.min(this.slides.length,first+count-1)} / ${this.slides.length}`;
    };
    const manual = direction => {this.paused=true;updateToggle();this.step(direction);};
    on(this.querySelector('[data-prev]'),'click',()=>manual(-1));
    on(this.querySelector('[data-next]'),'click',()=>manual(1));
    if(this.toggle) on(this.toggle,'click',()=>{this.paused=!this.paused;updateToggle();});
    on(this,'mouseenter',()=>this.hovered=true); on(this,'mouseleave',()=>this.hovered=false);
    on(this,'focusin',()=>this.focused=true);on(this,'focusout',e=>this.focused=this.contains(e.relatedTarget));
    on(this.track,'pointerdown',()=>{this.paused=true;updateToggle();});
    on(this.track,'scroll',update);on(window,'resize',update);
    on(this.reduced,'change',()=>{if(this.reduced.matches){this.paused=true;updateToggle();}});
    this.observer=new IntersectionObserver(entries=>this.visible=entries[0].isIntersecting,{threshold:.2});this.observer.observe(this);
    if(this.dataset.autoplay==='true') this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.focused&&this.visible&&!document.hidden&&!this.reduced.matches)this.step(1);},6000);
    this.querySelector('.lfd-brands__controls').hidden=false;updateToggle();update();
  }
  disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfd-player-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('de').trim();
  const init = root => root.querySelectorAll('[data-lfd-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const cards = [...gallery.querySelectorAll('[data-gallery-card]')];
    const search = gallery.querySelector('[data-gallery-search]');
    const stock = gallery.querySelector('[data-gallery-stock]');
    const update = () => {
      const term = normalize(search.value);
      let count = 0;
      cards.forEach(card => {
        card.hidden = !normalize(card.dataset.playerName).includes(term) || (stock.checked && card.dataset.hasProducts !== 'true');
        if (!card.hidden) count++;
      });
      gallery.querySelector('[data-gallery-results]').textContent = gallery.dataset.countLabel.replace('[count]', count);
      gallery.querySelector('[data-gallery-empty]').hidden = count !== 0;
    };
    search.addEventListener('input', update);
    stock.addEventListener('change', update);
    gallery.querySelector('[data-gallery-tools]').hidden = false;
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfd-player-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lfd-player-slideshow')) customElements.define('lfd-player-slideshow', class extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.lfd-show__track');
    this.slides = [...this.querySelectorAll('.lfd-show__slide')];
    if (this.slides.length < 2) return;
    this.abort = new AbortController();
    const on = (el, name, fn) => el.addEventListener(name, fn, {signal:this.abort.signal});
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.reduced.matches;
    this.hovered = false; this.focused = false; this.visible = false;
    this.toggle = this.querySelector('[data-toggle]');
    const updateToggle = () => {if(this.toggle){this.toggle.textContent=this.paused?this.dataset.play:this.dataset.pause;this.toggle.setAttribute('aria-pressed',String(this.paused));}};
    this.step = direction => {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 1) return;
      const width = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      let left = this.track.scrollLeft + direction * width;
      if(direction > 0 && this.track.scrollLeft >= max - 3) left = 0;
      if(direction < 0 && this.track.scrollLeft <= 3) left = max;
      this.track.scrollTo({left,behavior:this.reduced.matches?'instant':'smooth'});
    };
    const update = () => {
      const left=this.track.scrollLeft; const width=this.slides[1].offsetLeft-this.slides[0].offsetLeft;
      const first=Math.round(left/width)+1; const count=Math.max(1,Math.round(this.track.clientWidth/width));
      this.querySelector('[data-position]').textContent=`${first}–${Math.min(this.slides.length,first+count-1)} / ${this.slides.length}`;
    };
    const manual = direction => {this.paused=true;updateToggle();this.step(direction);};
    on(this.querySelector('[data-prev]'),'click',()=>manual(-1));
    on(this.querySelector('[data-next]'),'click',()=>manual(1));
    if(this.toggle) on(this.toggle,'click',()=>{this.paused=!this.paused;updateToggle();});
    on(this,'mouseenter',()=>this.hovered=true); on(this,'mouseleave',()=>this.hovered=false);
    on(this,'focusin',()=>this.focused=true);on(this,'focusout',e=>this.focused=this.contains(e.relatedTarget));
    on(this.track,'pointerdown',()=>{this.paused=true;updateToggle();});
    on(this.track,'scroll',update);on(window,'resize',update);
    on(this.reduced,'change',()=>{if(this.reduced.matches){this.paused=true;updateToggle();}});
    this.observer=new IntersectionObserver(entries=>this.visible=entries[0].isIntersecting,{threshold:.2});this.observer.observe(this);
    if(this.dataset.autoplay==='true') this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.focused&&this.visible&&!document.hidden&&!this.reduced.matches)this.step(1);},6000);
    this.querySelector('.lfd-show__controls').hidden=false;updateToggle();update();
  }
  disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfd-pro-players"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('de').trim();
  const init = root => {
    root.querySelectorAll('[data-player-directory]').forEach(directory => {
      if (directory.dataset.ready) return;
      directory.dataset.ready = 'true';
      const cards = [...directory.querySelectorAll('[data-player-card]')];
      const search = directory.querySelector('[data-player-search]');
      const stock = directory.querySelector('[data-player-stock]');
      const more = directory.querySelector('[data-player-more]');
      const results = directory.querySelector('[data-player-results]');
      let limit = 12;
      const update = () => {
        const term = normalize(search.value);
        const matches = cards.filter(card => normalize(card.dataset.playerName).includes(term) && (!stock.checked || card.dataset.playerHasProducts === 'true'));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        results.textContent = directory.dataset.countLabel.replace('[count]', matches.length);
        more.hidden = matches.length <= limit;
        directory.querySelector('[data-player-empty]').hidden = matches.length > 0;
      };
      [search, stock].forEach(input => input.addEventListener('input', () => { limit = search.value.trim() ? cards.length : 12; update(); }));
      more.addEventListener('click', () => {
        const before = new Set(cards.filter(card => !card.hidden));
        limit += 24;
        update();
        const firstNew = cards.find(card => !card.hidden && !before.has(card));
        const target = firstNew && (firstNew.querySelector('a') || firstNew);
        if (target) { if (!target.matches('a')) target.tabIndex = -1; target.focus({preventScroll:true}); }
      });
      directory.querySelector('.lfd-pro__tools').hidden = false;
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();
			this.spinnerIcon = this.querySelector('.cart__note-loading');
			this.successIcon = this.querySelector('.cart__note-success');
			this.textarea = this.querySelector('textarea');
			this.cartButtons = document.querySelector('.cart__ctas');

			this.textarea.addEventListener(
				'input',
				debounce((event) => {
					this.spinnerIcon.style.display = 'block';
					this.successIcon.style.display = 'none';
					this.cartButtons.style.pointerEvents = 'none';
					this.cartButtons.style.opacity = '0.7';

					const body = JSON.stringify({ note: event.target.value });

					fetch(`${routes.cart_update_url}`, {
						...fetchConfig(),
						...{ body },
					})
						.then((response) => {
							if (!response.ok) {
								throw new Error('Network response was not ok');
							}
							return response.json();
						})
						.then((data) => {
							this.successIcon.style.display = 'block';

							setTimeout(() => {
								this.successIcon.style.display = 'none';
							}, 2000);
						})
						.catch((error) => {
							console.error(
								'There was a problem with the fetch operation:',
								error,
							);
						})
						.finally(() => {
							this.spinnerIcon.style.display = 'none';
							this.cartButtons.removeAttribute('style');
						});
				}, 300),
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
